import { Component } from '@angular/core';

@Component({
  selector: 'app-circles',
  standalone: true,
  imports: [],
  templateUrl: './circles.component.html',
  styleUrl: './circles.component.scss'
})
export class CirclesComponent {

  circles: HTMLElement[] = [];
  translateValues: { x: number, y: number }[] = [];

  getRandomTranslateValue(): number {
    return Math.random() > 0.5 ? 10 : -10;
  }

  updateTranslate(index: number): void {
    let { x, y } = this.translateValues[index];

    const newTranslateX = x + this.getRandomTranslateValue();
    const newTranslateY = y + this.getRandomTranslateValue();

    this.translateValues[index].x = Math.max(Math.min(newTranslateX, 20), -20);
    this.translateValues[index].y = Math.max(Math.min(newTranslateY, 20), -20);
    this.circles[index].style.transform = `translate(${this.translateValues[index].x}%, ${this.translateValues[index].y}%)`;
  }

  ngAfterViewInit(){
      this.circles = [
        document.querySelector(`.circle-1`) as HTMLElement,
        document.querySelector(`.circle-2`) as HTMLElement,
        document.querySelector(`.circle-3`) as HTMLElement
      ];
    
      // Initialize translate values for each circle
      this.translateValues = this.circles.map(() => ({ x: 0, y: 0 }));
      
    this.circles.forEach((_, index) => {
      setInterval(() => this.updateTranslate(index), 1500);
    });
  }
}
